import type { FC, ReactNode } from 'react';

type Props = {
  id: string,
  open: boolean,
  children: ReactNode,
};

const SlideToggle: FC<Props> = ({ id, open, children }) => {
  return (
    <div id={'js-nav-' + id} className={'globalNavAccordionWrap'} aria-hidden={!open}>
      {children}
    </div>
  );
};

export default SlideToggle;